import React, { FC } from 'react'
import { isMobileOnly, isMobile } from 'react-device-detect'

import { Button } from '../../components/button'
import { Column } from '../../components/column'
import { Content } from '../../components/content'
import { Row } from '../../components/row'
import { Text, TextTranslate } from '../../components/text'

import { useStyle } from './not-found.styles'

type ErrorLayoutText = {
  text: string
  tx: TextTranslate
}

type ErrorLayoutProps = {
  code?: string
  label?: ErrorLayoutText
  message: ErrorLayoutText
  onHome: () => void
}

export const ErrorLayout: FC<ErrorLayoutProps> = ({
  code,
  label,
  message,
  onHome
}) => {
  const classes = useStyle()
  const textPreset = isMobileOnly ? 'h6' : 'h2'
  const codePreset = isMobileOnly ? 'h1Mobile' : 'notFound'
  const titlePreset = isMobileOnly ? 'h1Mobile' : 'h1'
  const messagePreset = isMobile ? 'h3Mobile' : 'h3'

  return (
    <Content className={classes.container} alignItems="flex-start">
      <Row fullWidth className={classes.row} alignItems="flex-start">
        <Column
          className={classes.firstColumn}
          justifyContent="flex-start"
          alignItems="flex-start"
        >
          <Text
            preset={textPreset}
            text="Ooops..."
            color="blue"
            tx="error.404.left.first.text"
          />
          {code && (
            <Text
              className={classes.errorNumber}
              preset={codePreset}
              text={code}
            />
          )}
          {label && (
            <Text
              className={classes.page}
              preset={textPreset}
              color="blue"
              {...label}
            />
          )}
        </Column>

        <Column className={classes.secondColumn} alignItems="flex-start">
          <Text
            className={classes.title}
            preset={titlePreset}
            text="Something went wrong here"
            tx="error.404.title.text"
          />
          <Text
            className={classes.textError}
            preset={messagePreset}
            {...message}
          />
          <Button
            className={classes.button}
            color="yellow"
            preset="borderButton"
            textColor="white"
            text="HOME"
            tx="error.404.button.text"
            onClick={onHome}
          />
        </Column>
      </Row>
    </Content>
  )
}
